// extracted by mini-css-extract-plugin
module.exports = {"grid":"recipe-grid-base_grid__Z3M_r"};